<template>
	<div class="container text-center" id="login">
		<h2 class="text-center mt-5"><i class="fas fa-spinner fa-spin fa-2x"></i></h2>
	</div>
</template>

<script>
	import axios from "axios";
	import apiMixins from "@/mixins/apiMixins";
	export default {
		name: "login",
		data() {
			return {
				login: {
					email: "",
					password: "",
				},
				errorMessage: "",
				showPassword: false,
			};
		},
		mixins: [apiMixins],
		mounted() {
			localStorage.clear();
			this.checkOrigin();
		},
		methods: {
			panelLogin(){
				this.errorMessage = "";
				let totalData = this.login;
				axios({
					method: "post",
					url: `${process.env.ROOT_API}api/login`,
					data: totalData,
					config: { headers: { "Content-Type": "multipart/form-data" } },
				}).then((response) => {
					if (response.data.status == 1) {
						this.$session.start();
						this.saveDataInLocalStorage(response);
						this.saveDataInSession(response);
						this.tintPanel();
						this.manageUserSites(response);
					} else {
						this.errorMessage = "E-mail ou senha inválidos";
					}
				});
			},
			saveDataInLocalStorage(response){
				const data = response.data
				localStorage.setItem("themeColor", data.application.main_color);
				localStorage.setItem("backgroundColor", data.application.background_color);
				localStorage.setItem("jwt", data.token);
				localStorage.setItem("ogImage", data.application.og_image);
				localStorage.setItem("ogDescription", data.application.og_description);
				localStorage.setItem("appleIcon", data.application.apple_icon);
				localStorage.setItem("showAffiliate", data.application.show_affiliate);
			},
			saveDataInSession(response){
				const data = response.data
				this.$session.set("jwt", data.token);
				this.$session.set("userEmail", data.email);
				this.$session.set("appKey", data.application.app_key);
				this.$session.set("appBaseDomain",data.application.app_base_domain);
				this.$session.set("appBaseDomain", data.application.app_base_domain);
				this.$session.set("appDefaultIdd", data.application.default_idd);
			},
			tintPanel(){
				document.documentElement.style.setProperty("--main-color", localStorage.getItem("themeColor"));
				document.documentElement.style.setProperty("--bg-color",localStorage.getItem("backgroundColor"));
			},
			async manageUserSites(response){
				if (response.data.sites.length > 0) {
					this.$store.dispatch("VERIFY_TOKEN");
					this.$store.dispatch("VERIFY_SITE");
					this.$session.set("welcome", response.data.sites[0].welcome);
					this.$session.set("animationMenu", response.data.sites[0].welcome);
					if (response.data.sites[0].wizard == 1) {
						this.$store.dispatch("userModule/GET_USER_MEDIAS", [this.$session.get('jwt'), localStorage.siteId]);
						this.$session.set("wizard", 1);
						this.goDashboard(localStorage.siteId);
					} else {
						this.$session.set("wizard", 0);
						localStorage.setItem("siteId", localStorage.siteId);
						this.goWizard(localStorage.siteId);
					}
				} else {
					let site = await this.createSite();
					this.$store.dispatch("VERIFY_TOKEN");
					this.$session.set("welcome", true);
					this.goWizard(site.siteId);
				}
			},
			goWizard(site) {
				this.$session.set("siteId", site);
				this.$router.push({
					name: "StepWizard",
					params: { stepWizard: 'StepWizardIntegrations' },
				});
			},
			goDashboard(site) {
				this.$session.set("siteId", site);
				this.$router.push("/dashboard");
			},
			passwordReveal() {
				this.showPassword = !this.showPassword;
			},
			async  createSite() {
				let totalData = "";
				let token = this.$session.get("jwt");
				let url = `/site/create`;

				let site = await this.requestApiData(url, "get", totalData);

				return site;
			},
			brandImage() {
				let url = window.location.hostname;
				if (url === "painel.sitejet.com.br") {
					return "https://sitejet.com.br/img/Logo-Sitejet.png";
				} else {
					return "https://ulisite.com/img/logo-uli.svg";
				}
			},
			checkOrigin(){
				let url = window.location.hostname;
				if (url != "localhost") {
					url = url.replace("painel.", "");
					window.open(`https://${url}/login`, "_self");
				}
			},
		},
	};
</script>

<style scoped>
	body {
		background-color: #f8f8fa;
	}
	.navbar-uli {
		padding-top: 11px;
		margin-bottom: 10px;
	}
	.navbar-uli a {
		color: #000;
		font-size: 16px;
	}
	.navbar-uli a:hover {
		text-decoration: none;
	}
	.logo-uli img {
		max-height: 118px;
		margin-top: 14px;
		margin-bottom: 20px;
		max-width: 300px;
	}
	.total-login h1 {
		font-size: 24px;
		font-weight: 700;
		margin-bottom: 20px;
	}
	form {
		width: 80%;
		max-width: 345px;
	}
	form button {
		width: 170px;
		height: 45px;
		font-size: 16px;
		font-weight: 700;
		margin-top: 12px;
	}
	input[type="email"],
	input[type="password"],
	input[type="text"] {
		margin: 0 0 18px 0;
		font-size: 16px;
		font-family: "Montserrat", sans-serif;
		padding: 6px 0 0 0;
	}
	input[type="password"],
	input[type="text"] {
		padding-right: 30px;
	}
	input[type="email"]::placeholder,
	input[type="password"]::placeholder,
	input[type="text"]::placeholder {
		/* Chrome, Firefox, Opera, Safari 10.1+ */
		color: #000;
		font-size: 16px;
		opacity: 1; /* Firefox */
	}

	input[type="email"]:-ms-input-placeholder,
	input[type="password"]:-ms-input-placeholder,
	input[type="text"]:-ms-input-placeholder {
		/* Internet Explorer 10-11 */
		color: #000;
		font-size: 16px;
	}

	input[type="email"]::-ms-input-placeholder,
	input[type="password"]::-ms-input-placeholder,
	input[type="text"]::-ms-input-placeholder {
		/* Microsoft Edge */
		color: #000;
		font-size: 16px;
	}
	.password-icon {
		height: 16px;
		position: absolute;
		right: 20px;
		top: 14px;
	}
	.password-icon:hover {
		cursor: pointer;
	}
	.error-alert {
		color: #f00;
		font-size: 11px;
	}
	.recovery-link {
		color: #333333;
		font-weight: 700;
		font-size: 14px;
	}
	footer p {
		color: #333333;
		margin-bottom: 0;
		font-size: 11px;
		line-height: 14px;
		font-family: "Open Sans", sans-serif;
	}
	footer a {
		color: #333333;
	}
	footer a:hover {
		color: #333333;
	}
	footer a:visited {
		color: #333333;
	}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue